import React, {Component} from 'react';
import PropTypes from "prop-types";

import './LoginPage.css';

class RegisterSuccess extends Component {

    static propTypes = {
        registerMail: PropTypes.string.isRequired,
        languages: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
        zskLinks: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        setUrlStateParams: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.translate;
        this.selectedLanguage = props.i18n.language;

    }

    handleInitPassword() {

        this.props.setUrlStateParams({
            show: 'initpassword',
            registerMail: this.props.registerMail
        });

    }

    handleCancel() {

        this.props.setUrlStateParams();

    }

    render() {

        const zskUrl = this.props.zskLinks.homePage;
        const zskHomePage = zskUrl + ((this.selectedLanguage === 'de') ? '/de' : '/en') ;
        const zskImprintLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.imprint;
        const zskPolicyLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.policy;
        const zskConditionLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.condition;
        const zskContactLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.contact;

        //const linkToDownload = (this.selectedLanguage === 'de') ? 'https://www.zsk.de/de/software/my-zsk.php' : 'https://www.zsk.de/en/software/my-zsk.php';
        const linkToDownload = 'https://shop.zsk.de/product/datacollector-software/';
        const linkToContact = (this.selectedLanguage === 'de') ? 'https://www.zsk.de/de/service/kontakt.php' : 'https://www.zsk.de/en/service/kontakt.php';
        const anchorToContact = <a href={linkToContact} target="_blank">{this.translate('contactForm')}</a>;

        return (
            <div>
                <div>
                    {/*<!-- BG Teaser + Verläufe -->*/}
                    <div id="MyTeaser" style={{display: 'block'}}>&nbsp;</div>
                    <div id="gradients" style={{display: 'block'}}>&nbsp;</div>
                    {/*<!-- / BG Teaser + Verläufe -->*/}

                    <header style={{display: 'block'}}>My.ZSK</header>

                    <div className="formdata">
                        <div className="clearfix">
                            <h1>{this.translate('registerSuccess')}</h1>

                            <div>
                                <ol>
                                    <li>{this.translate('registerSuccessNote1')}</li>
                                    <li>{this.translate('registerSuccessNote2')} {this.props.registerMail}</li>
                                    <li>{this.translate('registerSuccessNote3')}</li>
                                    <li>{this.translate('registerSuccessNote4').replace('__LINK_TO_CONTACT__', '')} {anchorToContact}.</li>
                                </ol>
                            </div>
                        </div>

                        <div className="clearfix">
                            <div className="clearfix">
                                <div className="buttonFrame fll" style={{marginRight: '5px'}}>
                                    <input type="button" value={this.translate('login')} onClick={() => this.handleCancel()}/>
                                </div>

                                {/*<div className="buttonFrame fll" style={{marginRight: '5px'}}>
                                    <input type="button" value={this.translate('initPassword')} onClick={() => this.handleInitPassword()}/>
                                </div>*/}

                                {/*<div className="buttonFrame fll">
                                    <a className="button" href={linkToDownload} target="_blank">{this.translate('download')}</a>
                                </div>*/}

                                <div className="buttonFrame flr">
                                    <a className="button" href="https://shop.zsk.de" target="_blank">{this.translate('myzskShop')}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer style={{display: 'block'}}>
                        <div className="rt">
                            <p>
                                <a href={zskHomePage} target="_blank" rel="noopener noreferrer">www.zsk.de</a>
                                |
                                <a href={zskConditionLink} target="_blank" rel="noopener noreferrer">{this.translate('termsAndConditions')}</a>
                                |
                                <a href={zskPolicyLink} target="_blank" rel="noopener noreferrer">{this.translate('privacyPolicy')}</a>
                                |
                                <a href={zskImprintLink} target="_blank" rel="noopener noreferrer">{this.translate('imprint')}</a>
                            </p>
                        </div>

                        <div className="lb">
                            <p>
                                <a href={zskContactLink} target="_blank" rel="noopener noreferrer" className="contactIcon">{this.translate('contact')}</a>
                            </p>
                        </div>

                        <div className="mig">Made in Germany</div>
                    </footer>
                </div>

                <style dangerouslySetInnerHTML={{__html: `#atlwdg-trigger {display : none;}`}}/>
            </div>
        );

    }

}

export default RegisterSuccess;
